import * as request from '../../request'
import * as serializers from './serializers'

export const getStoreStatuses = async () => {
  try {
    const res = await request.get('v1/filters/store-status', {
      params: {
        isSimpleList: true
      }
    })

    return serializers.getStoreStatuses(res)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const getStoreGroups = async () => {
  try {
    const res = await request.get('v1/filters/store-groups', {
      params: {
        isSimpleList: true
      }
    })

    return serializers.getStoreGroups(res)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const getStoreProducts = async () => {
  try {
    const res = await request.get('v1/filters/store-products', {
      params: {
        isSimpleList: true
      }
    })

    return serializers.getStoreProducts(res)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const getNetworks = async () => {
  try {
    const res = await request.get('v1/filters/geography-networks', {
      params: {
        isSimpleList: true
      }
    })

    return serializers.getNetworks(res)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const getSubsidiary = async () => {
  try {
    const res = await request.get('v1/filters/geography-subsidiaries', {
      params: {
        isSimpleList: true
      }
    })

    return serializers.getSubsidiary(res)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const getPartners = async () => {
  const res = await request.get('v1/filters/partners', {
    params: {
      isSimpleList: true,
      perPage: 200
    }
  })

  return serializers.getPartners(res)
}

export const getPriorityMatrices = async (params = {}) => {
  try {
    const res = await request.get('v1/filters/store-priority-matrices', {
      params: {
        isSimpleList: true,
        ...params
      }
    })

    return serializers.getPriorityMatrices(res)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const getSegments = async () => {
  try {
    const res = await request.get('v1/filters/store-segments', {
      params: {
        isSimpleList: true,
        perPage: 200
      }
    })

    return serializers.getPriorityMatrices(res)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const getSubSegments = async () => {
  try {
    const res = await request.get('v1/filters/store-subsegments', {
      params: {
        isSimpleList: true,
        perPage: 200
      }
    })

    return serializers.getPriorityMatrices(res)
  } catch (err) {
    return Promise.reject(err)
  }
}
